import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { getFacilityPageDataOffice } from '@/services/store-locator';
import { BRAND_NAME_EN, BRAND_NAME_FR } from '@/utils/constants';

const AddressComponent = (props: any) => {
  const { facilityData, isDesktop } = props;
  const { locale }: any = useRouter();

  const [officeAddressName, setOfficeAddressName] = useState(null);

  const getFacilityDataOffice = async (defaultBrand: string) => {
    const getOffice = await getFacilityPageDataOffice(
      facilityData?.attributes?.Office_Facility_ID,
      defaultBrand,
      locale
    );
    const officeName = getOffice?.data?.data[0]?.attributes?.Address?.Street_1;
    setOfficeAddressName(officeName);
  };

  useEffect(() => {
    let defaultBrand = BRAND_NAME_EN;
    if (locale === 'fr') defaultBrand = BRAND_NAME_FR;
    getFacilityDataOffice(defaultBrand);
  }, [facilityData]);

  const Address = facilityData?.attributes?.Address;
  const placeId = facilityData?.attributes?.Google_PlaceID;
  const PhoneNumber = facilityData?.attributes?.Support?.Phone_Number;
  const GMBNumber = facilityData?.attributes?.Support?.GMB_Phone_Number;

  return (
    <>
      <div className="sv-address-navigation d-flex align-items-center flex-md-wrap">
        <div className="d-flex align-items-center addressNavigation">
          <p className="sv-storeAddress mb-0">
            {Address?.Street_1}
            {Address?.Street_2}, {Address?.City} {Address?.Postal_Code}
            {officeAddressName && ` (Office: ${officeAddressName})`}
          </p>
          <button
            className="btn sv-navigation-btn ms-2 borderless-btn"
            aria-label="Open Google Maps directions"
          >
            <a
              href={`https://www.google.com/maps/search/?api=1&query=%20&query_place_id=${placeId} `}
              className="borderless-btn text-decoration-none"
              target="_blank"
              rel="noreferrer"
            >
              <img src="/images/navigation-pointer.svg" alt="Navigation" />
            </a>
          </button>
        </div>
        <div className={`${isDesktop ? 'w-100' : ''} mt-md-3`}>
          <button className="btn sv-revamp-blue-btn" aria-label="Call store">
            <a
              href={`tel:${PhoneNumber || GMBNumber}`}
              className="text-decoration-none text-white"
            >
              <img src="/images/sv-phone-icon.svg" alt="phone icon" />
              <span className="ms-2">
                {isDesktop ? PhoneNumber || GMBNumber : 'Call Store'}
              </span>
            </a>
          </button>
        </div>
      </div>
    </>
  );
};

export default AddressComponent;
